<template>
    <div
        class="page-wrapper"
        style="min-height: 100dvh">
        <div
            class="breadcrumb-wrap bg-spring d-flex align-items-center justify-content-center"
            style="min-height: 100dvh">
            <img
                src="../../assets/images/breadcrumb/br-shape-1.png"
                alt="Image"
                class="br-shape-one xs-none" />
            <img
                src="../../assets/images/breadcrumb/br-shape-2.png"
                alt="Image"
                class="br-shape-two xs-none" />
            <img
                src="../../assets/images/breadcrumb/br-shape-3.png"
                alt="Image"
                class="br-shape-three moveHorizontal sm-none" />
            <img
                src="../../assets/images/breadcrumb/br-shape-4.png"
                alt="Image"
                class="br-shape-four moveVertical sm-none" />
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-12">
                        <div class="breadcrumb-img">
                            <img
                                v-if="success"
                                style="max-width: 400px"
                                src="../../assets/images/breadcrumb/breadcrumb-1.png" />
                            <img
                                v-else
                                src="../../assets/images/404.png"
                                alt="Image" />
                        </div>
                    </div>
                    <div class="col-12">
                        <div
                            v-if="success"
                            class="breadcrumb-title">
                            <h2 class="header-blue-tf-color text-center">SUCCESS</h2>
                            <p class="text-center h2">
                                Successfully verified mail - Thank you for confirming your email.
                            </p>
                        </div>
                        <div
                            v-else
                            class="breadcrumb-title">
                            <h2 class="text-center">Oops!</h2>
                            <p class="text-center h2">Error - An error occurred while verifying your email.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from "axios";
    import PageTitle from "../Common/PageTitle";
    import Footer from "../Layouts/Footer";
    import RecoverPassword from "../RecoverPassword/RecoverPassword";
    export default {
        name: "EmailVerification",
        components: {
            PageTitle,
            RecoverPassword,
            Footer,
        },
        data() {
            return {
                loading: true,
                success: null,
                url: "http://192.168.0.133/",
            };
        },
        methods: {
            async verifyEmail() {
                this.loading = true;
                const response = await axios.put(`https://total.aw/mdw/controller.php/customers`, {
                    customerId: this.$route.params.id,
                    firstName: null,
                    lastName: null,
                    email: "",
                    emailNumber: this.$route.query.EmailNumber,
                });
                this.success = response.data.statusResult;
                this.loading = false;
            },
        },
        created() {
            this.verifyEmail();
        },
    };
</script>
